document.querySelectorAll('.js-subscribe-bar-top-trigger .toggle-container .tabToggel_box')
  .forEach(function(item) {
    item.addEventListener('click', function() {
      const allParents = document.querySelectorAll('.js-subscribe-bar-top-trigger');
      const isActive = allParents[0]?.classList.contains('active');
      allParents.forEach(function(parent) {
        if (isActive) {
          parent.classList.remove('active');
        } else {
          parent.classList.add('active');
        }
      });
    });
  });
document.querySelectorAll('.tabel_change_effect .toggle-container .tabToggel_box')
  .forEach(function(item) {
    item.addEventListener('click', function() {
      const allParents = document.querySelectorAll('.tabel_change_effect');
      const isActive = allParents[0]?.classList.contains('active');
      allParents.forEach(function(parent) {
        if (isActive) {
          parent.classList.remove('active');
        } else {
          parent.classList.add('active');
        }
      });
    });
  });